import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { ValidateAndUploadSurveyRulesRPC } from "./validateAndUploadSurveyRulesRPC";

export class ValidateAndUploadSurveyRulesRPCClientImpl extends ValidateAndUploadSurveyRulesRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: ValidateAndUploadSurveyRulesRPC.Request): Promise<LeoRPCResult<ValidateAndUploadSurveyRulesRPC.Response, ValidateAndUploadSurveyRulesRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-rules/ValidateAndUploadSurveyRules",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      ValidateAndUploadSurveyRulesRPC.ResponseDTO,
      ValidateAndUploadSurveyRulesRPC.Errors.ErrorsDTO,
      ValidateAndUploadSurveyRulesRPC.Response,
      ValidateAndUploadSurveyRulesRPC.Errors.Errors
    >(
      response,
      "survey-rules/ValidateAndUploadSurveyRules",
      ValidateAndUploadSurveyRulesRPC.Response.fromDTO,
      ValidateAndUploadSurveyRulesRPC.Errors.fromDTO
    );
  }
}
